export default "__VITE_ASSET__CtlVK1uk__"